import { Helpers } from '@bode-canada/core';

const QUERY_SEPARATOR = '&';

export default class QueryParameterHelper {
  static buildQueryString(query) {
    const mappedQuery = Object
      .keys(query)
      .filter((key) => !!query[key])
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(query[key])}`);

    return Helpers.StringHelper.joinStrings(mappedQuery, QUERY_SEPARATOR);
  }
}
